import { styled } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Column, div, FormLabel } from 'lqx-react/lib';
import { DigiSelect } from './select';

export const numberInputStyles = makeStyles({
    numericInput: {
        color: '#000',
        width: '100%',
        border: '1px solid #E3E9ED',
        padding: '4px 3px 3px 3px',
        fontSize: '14px',
        boxSizing: 'border-box',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 2,
        backgroundColor: '#FFF',
        textAlign: 'end',

        '&:focus': {
            backgroundColor: '#F6FCFF',
            border: '1px solid #1084D3',
            outline: 'none',
        },

        '&:disabled': {
            backgroundColor: 'rgba(227,233,237,0.25)',
            border: '1px solid #E3E9ED',
        },

        '&:read-only': {
            border: 'none'
        },

        '&:hover:read-write': {
            border: '1px solid #1084D3',
        }
    }
});

export const StyledFormLabel = styled(FormLabel)({
    alignSelf: 'inherit',
    paddingLeft: 4
})

export const AssetLabel = div({
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
    color: '#8695A4',
    padding: '5px'
});

export const AssetColumn = styled(Column)({
    minWidth: '200px',
    marginBottom: '5px'
});

export const ParticipantSelect = styled(DigiSelect)({
    width: '50px'
});

export const AdditionalFields = div({
    marginTop: '15px',
    marginBottom: '15px'
});